import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showLoading, hideLoading } from '../../store/slices/loadingState';

import RenderContent from './RenderContent';
import TooltipInfo from './TooltipInfo/tooltipInfo';
import './Client.scss';

const Sections = ({ clientDetails, selectedClient, breadcrumbs }) => {
  const dispatch = useDispatch();
  const [viewSelect, setViewSelect] = useState(1);
  const history = useHistory();

  useEffect(() => {
    if (!clientDetails || !selectedClient) {
      dispatch(showLoading());
    } else {
      dispatch(hideLoading());
    }
  }, [clientDetails, selectedClient, dispatch]);

  if (!clientDetails || !selectedClient) {
    return null;
  }

  const clientName = clientDetails.clientName;

  const encodeClientName = (clientName) => {
    return clientName
      .replace(/\s+/g, '%20')
      .replace(/\//g, '%2F')
      .replace(/'/g, '%1D')
      .replace(/’/g, '%1E');
  };

  const encodedClientName = encodeClientName(clientName);

  const redirectToCalendar = () => {
    history.push(`/calendar/${encodedClientName}`);
  };

  return (
    <div>
      <div className="px-8">
        <div className="d-flex p-2 align-items-center justify-content-between">
          <div className="ps-2">
            {/* Breadcrumbs */}
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                {breadcrumbs.map((crumb, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === breadcrumbs.length - 1 ? 'active' : ''
                    }`}>
                    {index === breadcrumbs.length - 1 ? (
                      crumb.name
                    ) : (
                      <a href={crumb.link}>{crumb.name}</a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
            <h4
              className="mg-b-0 tx-spacing--1"
              style={{ display: 'flex', alignItems: 'center' }}>
              {clientName}
              <TooltipInfo
                accountOwner={clientDetails.accountOwner}
                accountStatus={clientDetails.accountStatus}
                clientFlags={clientDetails.clientFlags}
              />
            </h4>
          </div>

          {/* Navigation */}
          <div className="d-flex align-items-center justify-content-end ms-auto col-sm-6 col-md-5 col-lg-auto mt-2 section-explore ml-3">
            <nav className="nav nav-pills">
              <button
                onClick={() => setViewSelect(1)}
                className={`nav-link ${
                  viewSelect === 1 || viewSelect === 2 ? 'active' : ''
                } px-3`}>
                <span>Business Info</span>
              </button>
              <button
                onClick={() => setViewSelect(3)}
                className={`nav-link ${viewSelect === 3 ? 'active' : ''} px-3`}>
                <span>Notes</span>
              </button>
              <button
                onClick={() => setViewSelect(4)}
                className={`nav-link ${viewSelect === 4 ? 'active' : ''} px-3`}>
                <span>GBP</span>
              </button>
              <button
                onClick={() => setViewSelect(5)}
                className={`nav-link ${viewSelect === 5 ? 'active' : ''} px-3`}>
                <span>Reviews</span>
              </button>
              <button
                onClick={() => setViewSelect(6)}
                className={`nav-link ${viewSelect === 6 ? 'active' : ''} px-3`}>
                <span>Image Library</span>
              </button>
            </nav>
          </div>

          <div
            className="btn-group ps-4"
            role="group"
            aria-label="Account and Calendar selector">
            <button type="button" className="btn btn-primary btn-inactive">
              Account
            </button>
            <button
              type="button"
              className="btn btn-light btn-active"
              onClick={redirectToCalendar}>
              Calendar
            </button>
          </div>
        </div>

        <RenderContent viewSelect={viewSelect} clientDetails={clientDetails} />
      </div>
    </div>
  );
};

export default Sections;
